export default "__VITE_ASSET__HdgyMQyJ__"